export default {
  backLinkProjects: 'All projects',
  readProjects: 'Discover the project',
  otherTitle: 'Other projects',
}
